import { useEffect } from "react";
import { config } from "../../utils/constants";
import { maskMobileNumber } from "../../common/MaskedMobileNo";

const RegistrationThanks = ({ setRequestStep, regsMobileNum, setRegsMobileNum, fullName, bloodGroup, setRegistrationThanks, translationMap }) => {
  useEffect(() => {
    window.parent.scrollTo(0, 0);
  }, []);

  return (
    <>
        <section className="w-100 clearfix BloodDonationMainSection" id="CoverPlanActive">
          <div className="container customContainer">
            <div className="Title_Inner_Box">
              <h6 className="MainTitleOne">
                {translationMap?.registerEmergency}
              </h6>
            </div>
            <div className="cover_inner_wrapper">
              <div className="cover_main_box1">
                <div className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible">
                  <button type="button" className="close" data-dismiss="alert">&times;</button>
                  <div className="Icon_box">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a>
                      <span className="material-symbols-outlined">
                        check_circle
                      </span>
                    </a>
                  </div>
                  <div className="alert_text">
                    <h6>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a>
                        {translationMap?.thankYou}
                      </a>
                    </h6>
                    <p className="number_txt">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a>
                        {translationMap?.registrationEmergencyMsg}
                      </a>
                    </p>
                  </div>
                </div>
                <div className="blood_contact_box">
                  <div className="info_box1">
                    <p className="Gray_Title">
                      {translationMap?.emergencyMsg}
                    </p>
                    <ul className="ul_box">
                      <li>
                        <p>
                          <span> {translationMap?.mobileNo}{": "}</span>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a>
                            {maskMobileNumber(regsMobileNum)}
                          </a>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>{translationMap?.bloodGroup}{": "} </span>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a>
                            {bloodGroup}
                          </a>
                        </p>
                      </li>
                    </ul>
                  </div>
                  <div className="info_box2">
                    <span>
                      <a className="bluetrans_btn_link" href={config?.dbdBackUrl} onClick={() => {
                      setRegistrationThanks(false);
                      setRegsMobileNum("");
                      window.parent.scrollTo(0, 0);
                    }}>
                         {translationMap?.backToDammi}
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    </>);

};

export default RegistrationThanks;